import React, { Component } from 'react';
import './Fields.css'
import './ProfileLocations.css'
import { fullCountryName } from '../helpers/functions';
import mapMarker from '../static/vectors/map-marker-alt.svg';
import checkCircle from '../static/vectors/check-circle.svg';
import Api from '../services/api';
import AuthService from '../services/auth';
import GoogleAutocomplete from 'react-google-autocomplete';
import Modal from 'react-modal';

class ProfileLocations extends Component {

  constructor(props) {
    super(props);

    this.state = {
      fields: {
        locations: [],
        deletedLocations: [],
      },
      newLocation: {
        city: '',
        country: '',
      },
      isModalOpen: false,
      modalMessage: '',
      canSubmit: false,
    };
  }

  componentDidMount() {
    (new Api()).get('/users/current',{}, AuthService.getAuthCookie())
      .then(response => {
        let { locations } = response.user;
        locations = locations.map(location => {
          return {
            city: location.city,
            country: location.country,
            id: location.id,
            primary: location.primary,
          }
        });

        locations.sort((a,b) => {
          return (a.primary) ? -1 : ((b.primary) ? 1 : 0);
        });
        this.setState({
          fields: {
            locations,
            deletedLocations: [],
          },
          newLocation: {
            city: '',
            country: '',
          },
          id: response.user.id,
        });
      });
  }

  handleSubmit(e) {
    e.preventDefault();
    let { fields, id } = this.state;

    (new Api()).put(`/users/${id}`, fields, AuthService.getAuthCookie())
      .then(response => {
        let { locations } = response.user;
        locations = locations.map(location => {
          return {
            city: location.city,
            country: location.country,
            id: location.id,
            primary: location.primary,
          }
        });

        locations.sort((a,b) => {
          return (a.primary) ? -1 : ((b.primary) ? 1 : 0);
        });
        this.setState({
          isModalOpen: true,
          canSubmit: false,
          modalMessage: response.message,
          fields: {
            locations,
            deletedLocations: [],
          },
          newLocation: {
            city: '',
            country: '',
          },
          id: response.user.id,
        });
      });
  }

  handleFieldChange(e, name) {
    let { newLocation } = this.state;
    if(name === 'location') {
      newLocation.city = e.name;
      let filteredAddressComponents = e.address_components.filter(el => (
        el.types.includes('country')
      ));
      newLocation.country = filteredAddressComponents[0].short_name;
      newLocation.primary = false;
      newLocation.id = 'new';
    }

    this.setState({ newLocation });
  }

  addLocation(e) {
    e.preventDefault();
    let { fields, newLocation } = this.state;
    if(newLocation.city.length > 0 && newLocation.country.length > 0) {
      fields.locations.push(newLocation);

      this.setState({
        fields,
        newLocation: {
          city: '',
          country: '',
        },
        canSubmit: true,
      });
    }
  }

  setPrimaryLocation(e, i){
    e.preventDefault();
    let { fields } = this.state;
    fields.locations.map(location => {
      location.primary = false;
      return location;
    });

    fields.locations[i].primary = true;

    fields.locations.sort((a,b) => {
      return (a.primary) ? -1 : ((b.primary) ? 1 : 0);
    });
    this.setState({
      fields,
      canSubmit: true, });
  }

  deleteLocations(e, i){
    e.preventDefault();
    let { fields } = this.state;

    const deletedId = fields.locations[i].id;

    if(deletedId !== 'new') {
      fields.deletedLocations.push(deletedId);
    }

    fields.locations.splice(i,1);

    this.setState({ fields,
    canSubmit: true, });

  }

  closeModal() {
    this.setState({
      isModalOpen: false,
    });
  }

  render() {
    const { fields, isModalOpen, modalMessage, canSubmit } = this.state;
    const { title } = this.props;
    return (
      <div className="col col-12 col-md-8">
        <div className="title">
          {title}
        </div>
        <form className="locations-form">
          <div className="row locations">
          {fields.locations.map((location, i) => {
            return (
              <div key={Math.random()} className="col col-12">
                <div className="location">
                  <div className="label">
                    {`${(location.primary)?'primary':`#${i+1}`} location`}
                  </div>
                  <div className="location-name">
                    <img src={mapMarker} alt="map marker" />
                    <div className="city">
                      {location.city}
                    </div>
                    <div className="country">
                      , {fullCountryName(location.country)}
                    </div>
                  </div>
                  {(!location.primary) &&
                  <div className="links">
                    <button
                      onClick={(e) => this.setPrimaryLocation(e, i)}
                    >
                      Set as primary
                    </button>
                    <button
                      onClick={(e) => this.deleteLocations(e, i)}
                    >
                      Delete
                    </button>
                  </div>}
                </div>
              </div>
            )
          })}
          </div>
          <div className="field-container google">
            <div className="field-title">Add locations</div>
            <div className="row">
              <div className="col">
                <GoogleAutocomplete
                  onPlaceSelected={place => this.handleFieldChange(place, 'location')}
                />
              </div>
            </div>
          </div>
          <button
            className="submit"
            onClick={(e) => {this.addLocation(e)}}
          >
            Add Location
          </button>
        </form>
        <button
          className="btn submit"
          onClick={(e) => {this.handleSubmit(e)}}
          disabled={!canSubmit}
        >
          Save profile
        </button>
        <Modal
          isOpen={isModalOpen}
          onRequestClose={() => {this.closeModal()}}
          contentLabel="Example Modal"
          style={{
            content: {
              top: '50%',
              bottom: 'auto',
              left: '50%',
              right: 'auto',
              transform: 'translate(-50%, -50%)',
            }
          }}
        >
          <div className="content text-center">
            <img src={checkCircle} alt="check" />
            <div className="message">{modalMessage}</div>
            <button onClick={() => {this.closeModal()}}> Close X</button>
          </div>
        </Modal>
      </div>
    )
  }
}

export default ProfileLocations;


// WEBPACK FOOTER //
// ./src/components/ProfileLocations.js